import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton
} from "react-admin";

export default function Customers(props) {
  return (
    <List {...props} title="Galleries">
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="email" />
        <EditButton />
      </Datagrid>
    </List>
  );
}
